import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
// Redux
import { useAppSelector } from 'hooks/useStore';
// Types
import QuizTypes from 'types/QuizTypes';
import PageTypes from 'types/PageTypes';
// Models
import IQuestion from 'models/Question';
import IPage from 'models/Page';
// Selectors
import { selectQuiz } from 'store/quiz/quizzesSelectors';
// Components
import Question from './Question';
// i18next
import { useTranslation } from 'react-i18next';

const TabContentCorrectAnswers:FC = () => {
  const { t } = useTranslation();

  const quiz = useAppSelector(selectQuiz);

  const { watch } = useFormContext();
  const questionsPages = quiz?.pages?.filter((page:IPage) => page.type === PageTypes.Question);
  const questions: IQuestion[] = quiz?.questions.filter(question => questionsPages?.some(page => page.refs.includes(question.ref))) || [];
  const watchedEndsDate = watch('endsDate');

  if (quiz?.type !== QuizTypes.Prediction) return null;
  if (!watchedEndsDate || Number(watchedEndsDate) >= new Date().getTime()) return (
    <div className="p-6 w-full">
      <h2 className="text-white text-xl leading-6 font-bold text-center">
        {t('pages.quizForm.correctAnswersTabDisabledHint')}
      </h2>
    </div>
  )
  return (
    <div className="w-full overflow-y-auto overflow-x-hidden">
      <h3 className="text-white text-md font-semibold px-6 pt-4 pb-3">
        {t('pages.quizForm.correctAnswersTabHint')}
      </h3>
      {questions.map((question, index) => (
        <Question key={question.ref} question={question} index={index} />
      ))}
    </div>
  )
}

export default TabContentCorrectAnswers;
